import { render, staticRenderFns } from "./MemberListWaitLayout.vue?vue&type=template&id=4489cb39&scoped=true&"
import script from "./MemberListWaitLayout.vue?vue&type=script&lang=js&"
export * from "./MemberListWaitLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4489cb39",
  null
  
)

export default component.exports